/** Production hostname apex for Navio web apps on the bynavio.com brand zone. */
const brandZoneApex = 'bynavio.com';

/** `{hostLabel}.bynavio.com` — a brand slug or a backoffice app name. */
export const brandZoneHost = (hostLabel: string): string => `${hostLabel}.${brandZoneApex}`;
